import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { getBoolean, getContrast, getNumber, getRandomColor, getUnit } from '../../utils/avatar.utils';

interface BeamData {
  backgroundColor: string;
  eyeSpread: number;
  faceColor: string;
  faceRotate: number;
  faceTranslateX: number;
  faceTranslateY: number;
  isCircle: boolean;
  isMouthOpen: boolean;
  mouthSpread: number;
  wrapperColor: string;
  wrapperRotate: number;
  wrapperScale: number;
  wrapperTranslateX: number;
  wrapperTranslateY: number;
}

@Component({
  selector: 'lib-avatar-beam',
  templateUrl: './avatar-beam.component.html',
  styleUrls: ['./avatar-beam.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AvatarBeamComponent implements OnInit {
  @Input({ required: true }) colors!: string[];
  @Input({ required: true }) name!: string;
  @Input() inputSize = 40;

  SIZE = 36;
  data: BeamData | undefined;

  ngOnInit() {
    this.data = this.generateData(this.name, this.colors);
  }

  generateData(name: string, colors: Array<string>): BeamData {
    const numFromName = getNumber(name);
    const range = colors && colors.length;
    const wrapperColor = getRandomColor(numFromName, colors, range);
    const preTranslateX = getUnit(numFromName, 10, 1);
    const wrapperTranslateX = preTranslateX < 5 ? preTranslateX + this.SIZE / 9 : preTranslateX;
    const preTranslateY = getUnit(numFromName, 10, 2);
    const wrapperTranslateY = preTranslateY < 5 ? preTranslateY + this.SIZE / 9 : preTranslateY;

    return {
      wrapperColor: wrapperColor,
      faceColor: getContrast(wrapperColor),
      backgroundColor: getRandomColor(numFromName + 13, colors, range),
      wrapperTranslateX: wrapperTranslateX,
      wrapperTranslateY: wrapperTranslateY,
      wrapperRotate: getUnit(numFromName, 360, null),
      wrapperScale: 1 + getUnit(numFromName, this.SIZE / 12, null) / 10,
      isMouthOpen: getBoolean(numFromName, 2),
      isCircle: getBoolean(numFromName, 1),
      eyeSpread: getUnit(numFromName, 5, null),
      mouthSpread: getUnit(numFromName, 3, null),
      faceRotate: getUnit(numFromName, 10, 3),
      faceTranslateX: wrapperTranslateX > this.SIZE / 6 ? wrapperTranslateX / 2 : getUnit(numFromName, 8, 1),
      faceTranslateY: wrapperTranslateY > this.SIZE / 6 ? wrapperTranslateY / 2 : getUnit(numFromName, 7, 2),
    };
  }
}
